module.exports = __webpack_public_path__ + "static/media/CRV-logo.29f067cf.jpg";